// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__7B-17","buttons":"RemoveExpirationActionButtons_buttons__35RYY"};